"use strict";require("./_string-trim")("trim",function(r){return function(){return r(this,3)}});